<template>
  <div id="planos">
    <SectionAtual />
    <SectionPlanos />
  </div>
</template>

<script setup>
import SectionPlanos from '@components/app/planos/partials/SectionPlanos.vue'
import SectionAtual from '@components/app/planos/partials/SectionAtual.vue'
</script>

<style scoped>
#planos {
  animation: fadeIn 0.3s linear;
  padding: 0 0 0 260px;
}
@media screen and (max-width: 1000px) {
  #planos {
    padding: 0;
  }
}
</style>
